"use client"

import { useState, useEffect } from "react"

const rawBackendUrl = process.env.REACT_APP_BACKEND_URL || "";
const backend_url = rawBackendUrl.startsWith("http://") || rawBackendUrl.startsWith("https://") ? rawBackendUrl : `https://${rawBackendUrl}`;
const API_URL = `${backend_url}/api`

const ModifierUser = ({ closeModuser, selectedUser, roles, setUsersData }) => {
  const [nomInput, setNomInput] = useState(selectedUser?.name || "")
  const [emailInput, setEmailInput] = useState(selectedUser?.email || "")
  const [roleId, setRoleId] = useState("")
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  const [loading, setLoading] = useState(false)

  // Récupérer le token
  const getToken = () => localStorage.getItem("access_token")

  useEffect(() => {
    if (selectedUser && roles.length > 0) {
      // Chercher le rôle par son nom
      const userRole = roles.find(r => r.name === selectedUser.role_name);
      if (userRole) {
        setRoleId(userRole.id);
      }
    }
  }, [selectedUser, roles]);

  const handleRoleChange = (e) => {
    setRoleId(e.target.value)
    setError("")
    setSuccess("")
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")
    setSuccess("")
    setLoading(true)

    // Trouver le rôle sélectionné
    const selectedRole = roles.find(r => r.id === parseInt(roleId));
    
    const userData = {
      name: nomInput.trim(),
      email: emailInput.trim(),
      role: parseInt(roleId), // Envoyer l'ID du rôle
    }

    console.log("Données envoyées:", userData);

    try {
      const token = getToken();
      if (!token) {
        setError("Vous devez être connecté");
        setLoading(false);
        return;
      }

      const response = await fetch(`${API_URL}/users/${selectedUser.id}/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(userData),
      })

      const responseData = await response.json();
      console.log("Réponse du serveur:", responseData);

      if (response.ok) {
        setSuccess("Utilisateur modifié avec succès!")
        
        // Mettre à jour localement sans recharger toute la liste
        setUsersData(prev => 
          prev.map(u => 
            u.id === selectedUser.id 
              ? { 
                  ...u, 
                  name: nomInput.trim(), 
                  email: emailInput.trim(),
                  role_name: selectedRole?.name,
                  role: selectedRole
                } 
              : u
          )
        )

        setTimeout(() => closeModuser(false), 1500)
      } else {
        const errorMessage = responseData.error || 
                            responseData.message || 
                            responseData.detail || 
                            "Erreur lors de la modification";
        setError(`Erreur: ${errorMessage}`)
      }
    } catch (error) {
      console.error("Fetch error:", error)
      setError("Une erreur est survenue. Veuillez réessayer.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <form onSubmit={handleSubmit} className="space-y-6">
          <h2 className="text-2xl font-semibold text-gray-800 text-center">
            Modifier un utilisateur
          </h2>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg text-sm">
              {error}
            </div>
          )}
          
          {success && (
            <div className="bg-green-50 border border-green-200 text-green-600 px-4 py-3 rounded-lg text-sm">
              {success}
            </div>
          )}

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nom complet
              </label>
              <input
                type="text"
                value={nomInput}
                onChange={(e) => setNomInput(e.target.value)}
                placeholder="Nom"
                disabled={loading}
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#5e17eb] disabled:bg-gray-100"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <input
                type="email"
                value={emailInput}
                onChange={(e) => setEmailInput(e.target.value)}
                placeholder="Email"
                disabled={loading}
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#5e17eb] disabled:bg-gray-100"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Rôle
              </label>
              <select
                value={roleId}
                onChange={handleRoleChange}
                disabled={loading || roles.length === 0}
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#5e17eb] disabled:bg-gray-100"
              >
                <option value="">
                  {roles.length === 0 ? "Chargement des rôles..." : "Choisir un rôle"}
                </option>
                {roles.map((roleItem) => (
                  <option key={roleItem.id} value={roleItem.id}>
                    {roleItem.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={() => closeModuser(false)}
              disabled={loading}
              className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition duration-200 disabled:opacity-50"
            >
              Annuler
            </button>

            <button
              type="submit"
              disabled={loading || !roleId}
              className="bg-[#5e17eb] text-white px-4 py-2 rounded-lg hover:bg-[#6C3CFF] transition duration-200 disabled:opacity-50 flex items-center gap-2"
            >
              {loading ? (
                <>
                  <span className="animate-spin">⏳</span>
                  Modification...
                </>
              ) : (
                "Modifier"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ModifierUser